import { Instagram, MapPin, Phone, Clock } from "lucide-react";
import { LOGO_URL, DELIVERY_LINKS } from "@/data/content";

const QUICK = [
  { label: "Home", href: "#home" },
  { label: "About", href: "#about" },
  { label: "Menu", href: "#menu" },
  { label: "Bar", href: "#bar" },
  { label: "Gallery", href: "#gallery" },
  { label: "Catering", href: "#catering" },
  { label: "Contact", href: "#contact" },
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative bg-[#0D0D0D] border-t border-[#C8A24A]/20 pt-20 pb-8 px-6 md:px-10">
      <div className="mx-auto max-w-[1400px] grid md:grid-cols-4 gap-12">
        <div>
          <div className="flex items-center gap-3 mb-5">
            <img src={LOGO_URL} alt="Ekaa" className="h-14 w-14 object-cover rounded-full ring-1 ring-[#C8A24A]/50" />
            <div>
              <p className="font-display text-3xl text-gold-gradient leading-none">Ekaa</p>
              <p className="text-[10px] tracking-[0.3em] uppercase text-[#D6D6D6]/60 mt-1">Flavors Meet Elegance</p>
            </div>
          </div>
          <p className="text-[#D6D6D6]/70 font-light text-sm leading-relaxed max-w-xs">
            Authentic Indian fine dining in the heart of Kitchener — premium tandoor,
            handcrafted cocktails, and unforgettable hospitality.
          </p>
        </div>

        <div>
          <h4 className="font-display text-xl text-white mb-5">Quick Links</h4>
          <ul className="space-y-3">
            {QUICK.map((q) => (
              <li key={q.href}>
                <a href={q.href} className="text-[#D6D6D6]/70 hover:text-[#C8A24A] transition-colors text-sm">{q.label}</a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-display text-xl text-white mb-5">Opening Hours</h4>
          <div className="flex items-start gap-3 text-[#D6D6D6]/80 text-sm mb-4">
            <Clock className="h-4 w-4 text-[#C8A24A] mt-0.5 shrink-0" />
            <div>
              <p>Every Day</p>
              <p className="text-[#C8A24A]">2:00 PM – 2:00 AM</p>
            </div>
          </div>
          <div className="flex flex-col gap-3">
            <a href={DELIVERY_LINKS.doordash} target="_blank" rel="noopener noreferrer" data-testid="footer-doordash" className="text-[#D6D6D6]/70 hover:text-[#C8A24A] transition-colors text-sm">Order on DoorDash</a>
            <a href={DELIVERY_LINKS.ubereats} target="_blank" rel="noopener noreferrer" data-testid="footer-ubereats" className="text-[#D6D6D6]/70 hover:text-[#C8A24A] transition-colors text-sm">Order on Uber Eats</a>
          </div>
        </div>

        <div>
          <h4 className="font-display text-xl text-white mb-5">Contact</h4>
          <ul className="space-y-4 text-sm">
            <li className="flex items-start gap-3 text-[#D6D6D6]/80">
              <MapPin className="h-4 w-4 text-[#C8A24A] mt-0.5 shrink-0" />
              700 Strasburg Road, Kitchener, ON
            </li>
            <li className="flex items-center gap-3 text-[#D6D6D6]/80">
              <Phone className="h-4 w-4 text-[#C8A24A] shrink-0" />
              <a href="tel:+15488898500" className="hover:text-[#C8A24A] transition-colors">(548) 889-8500</a>
            </li>
            <li>
              <a href="https://www.instagram.com/ekaa_cuisine" target="_blank" rel="noopener noreferrer" data-testid="footer-instagram" className="inline-flex items-center gap-3 text-[#D6D6D6]/80 hover:text-[#C8A24A] transition-colors">
                <Instagram className="h-4 w-4 text-[#C8A24A]" /> @ekaa_cuisine
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="mx-auto max-w-[1400px] mt-16 pt-6 border-t border-[#C8A24A]/15 flex flex-col md:flex-row items-center justify-between gap-3">
        <p className="text-[#D6D6D6]/50 text-xs tracking-wide">© 2025 Ekaa. All Rights Reserved.</p>
        <p className="text-[#D6D6D6]/40 text-xs tracking-[0.2em] uppercase">Where Flavors Meet Elegance</p>
      </div>
    </footer>
  );
}
